module.exports = __webpack_public_path__ + "assets/82d9fbbb7525e0a31c6ba504dbc44af4.png";